import { render, staticRenderFns } from "./Garanzie.vue?vue&type=template&id=60404e24"
import script from "./Garanzie.vue?vue&type=script&lang=js"
export * from "./Garanzie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports